module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/Lupa.4b08b619.svg";